// Module
var code = "<!-- ko with: FormDesignerControl--> <div class=\"flex !screen-height\" data-bind=\"template: {\r\n\t                    name: $data.GetTemplateName.bind($data),\r\n\t                    afterRender: $data.AfterRender.bind($data)\r\n\t                },\r\n\t                class: ScreenType()\"></div> <!-- /ko -->";
// Exports
export default code;